import { liveboardAndDataObjects } from "./extractHeadersLiveboards";

function escapeCsv(value: unknown): string {
  if (value === undefined || value === null) return "";
  const str = String(value);
  // Escape double quotes by doubling them
  const escaped = str.replace(/"/g, '""');
  // Wrap in quotes if the field contains a comma, newline or quote
  return /[",\n]/.test(escaped) ? `"${escaped}"` : escaped;
}

/**
 * Convert an array of liveboardAndDataObjects to a CSV string.
 *
 * @param data                  The input array.
 * @param url                   URL suffix of the resource.
 * @param emptySpaceWhenArray   If true, if a resource has multiple child objects, the parent object will not be printed multiple for each child object.
 * @returns      CSV text where each line represents a child object
 *               (or a parent row when there are no children).
 */
export function metadataToCsv(
  data: liveboardAndDataObjects[],
  url: string,
  emptySpaceWhenArray: boolean,
  isLiveboardData: boolean,
): string {
  // Header row – order matters for readability
  const headers = [
    "parentName",
    "parentURL",
    "approximatedCreationDate",
    "childName",
    "childURL",
    "description",
  ];
  const rows: string[] = [];

  // Add header line
  rows.push(headers.map(escapeCsv).join(","));

  const emptyFields = [
    escapeCsv(""),
    escapeCsv(""),
    escapeCsv(""),
    escapeCsv(""),
  ];

  // Sort data

  const sortedData = data.sort((a, b) => {
    return a.parentName.localeCompare(b.parentName);
  });

  // Process each parent entry
  for (const item of sortedData) {
    const parentIDSuffix = isLiveboardData ? "pinboard/" : "data/tables/";
    const baseFields = [
      escapeCsv(item.parentName),
      escapeCsv(url + parentIDSuffix + item.parentID),
      escapeCsv(item.creationDate),
    ];

    // If there are child objects, emit one row per child
    if (item.childObjects && item.childObjects.length > 0) {
      let alreadyPrintedParentData: boolean = false;
      for (const child of item.childObjects) {
        const childFields = [
          escapeCsv(child.name),
          escapeCsv(url + "data/tables/" + child.id),
        ];

        if (alreadyPrintedParentData && emptySpaceWhenArray) {
          rows.push([...emptyFields, ...childFields, ""].join(","));
        } else {
          rows.push([...baseFields, ...childFields, ""].join(","));
        }
        alreadyPrintedParentData = true;
      }
    } else {
      // No children – leave child columns empty
      rows.push([...baseFields, "", "", ""].join(","));
    }
  }

  // Join all rows with CRLF (Windows‑style) or LF – both work fine
  return rows.join("\r\n");
}
